import React, { useEffect } from 'react';
import axios from 'axios';
import { APP_PATHS } from '../../helpers/inEadinApp';
import { ROUTES } from '../../consts/general';

export const APP_HANDOFF_PATH = '/app-handoff';

// #token=<jwt>&to=<app page>. The token rides in the fragment, which never
// reaches the server or its logs.
export function parseHandoff(hash) {
  const params = new URLSearchParams(String(hash || '').replace(/^#/, ''));
  const to = params.get('to');
  return {
    token: params.get('token') || null,
    to: APP_PATHS.includes(to) ? to : ROUTES.RECEIVED_SESSIONS,
  };
}

export default function AppHandoff() {
  useEffect(() => {
    const { token, to } = parseHandoff(window.location.hash);
    window.history.replaceState(null, '', window.location.pathname);
    if (!token) {
      window.location.replace(to);
      return;
    }
    axios.post('/api/v1/auth/app-session', null, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    })
      .then(() => window.location.replace(to))
      .catch(() => window.location.replace('/signin'));
  }, []);

  return <div className="p-6 text-base text-[#5b6170]">Opening…</div>;
}
